// 资金管理
const ProfileLabelGroup = () => import('@/view/profile/profile-label-group.vue'); // 
const ProfileLabelGroupModule = () => import('@/view/profile/profile-label-group-module.vue'); // 
const ProfileLabelGroupItem = () => import('@/view/profile/profile-label-group-item.vue'); // 
const BatchUpdateLabel = () => import('@/view/profile/batch-update-label.vue'); 
const Filter = () => import('@/view/profile/filter.vue'); 
const UserProfile = () => import('@/view/profile/user-profile.vue'); 
const UserProfileDetail = () => import('@/view/profile/user-profile-detail.vue'); 
const HighFrequencyLabel = () => import('@/view/profile/high-frequency-label.vue'); 
const AiRules = () => import('@/view/profile/ai-rules.vue'); 
const AiRulesNew = () => import('@/view/profile/ai-rules-new.vue'); 



export default [
  {
    path: '/profile-label-group',
    name: 'ProfileLabelGroup',
    component: ProfileLabelGroup
  },
  {
    path: '/profile-label-group-module',
    name: 'ProfileLabelGroupModule',
    component: ProfileLabelGroupModule
  },
  {
    path: '/profile-label-group-item',
    name: 'ProfileLabelGroupItem',
    component: ProfileLabelGroupItem
  },
  {
    path: '/batch-update-label',
    name: 'BatchUpdateLabel',
    component: BatchUpdateLabel
  },
  {
    path: '/profile-filter',
    name: 'Filter',
    component: Filter
  },
  {
    path: '/high-frequency-label',
    name: 'HighFrequencyLabel',
    component: HighFrequencyLabel
  },
  {
    path: '/user-profile',
    name: 'UserProfile',
    component: UserProfile
  },
  {
    path: '/user-profile-detail',
    name: 'UserProfileDetail',
    component: UserProfileDetail
  },
  {
    path: '/ai-rules',
    name: 'AiRules',
    component: AiRules
  },
  {
    path: '/ai-rules-new',
    name: 'AiRulesNew',
    component: AiRulesNew
  }
];